// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--1LwqZ";
export var e404 = "hero-module--e404--2ZrY8";